module.exports = __webpack_public_path__ + "static/media/Pinned.71fcb023.svg";